module.exports = __webpack_public_path__ + "img/1359.7cf952ac.gif";